"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presentProfile = void 0;
exports.pronounsAsText = pronounsAsText;
var _solidUi = require("solid-ui");
var _solidLogic = require("solid-logic");
var _validateColor = require("validate-color");
function pronounsAsText(subject) {
  let pronouns = _solidLogic.store.anyJS(subject, _solidUi.ns.solid('preferredSubjectPronoun')) || '';
  if (pronouns) {
    const them = _solidLogic.store.anyJS(subject, _solidUi.ns.solid('preferredObjectPronoun'));
    if (them) {
      pronouns += '/' + them;
      const their = _solidLogic.store.anyJS(subject, _solidUi.ns.solid('preferredRelativePronoun'));
      if (their) {
        pronouns += '/' + their;
      }
    }
    pronouns = ' (' + pronouns + ') ';
  }
  return pronouns || '';
}
const presentProfile = (subject, store) => {
  const name = _solidUi.utils.label(subject);
  const imageSrc = _solidUi.widgets.findImage(subject);
  const role = store.anyValue(subject, _solidUi.ns.vcard('role'));
  const orgName = store.anyValue(subject, _solidUi.ns.vcard('organization-name')); // @@ Search whole store

  const address = store.any(subject, _solidUi.ns.vcard('hasAddress'));
  const countryName = address != null ? store.anyValue(address, _solidUi.ns.vcard('country-name')) : null;
  const locality = address != null ? store.anyValue(address, _solidUi.ns.vcard('locality')) : null;
  const {
    backgroundColor,
    highlightColor
  } = getColors(subject, store);
  const pronouns = pronounsAsText(subject);
  return {
    name,
    imageSrc,
    introduction: formatIntroduction(role, orgName),
    location: formatLocation(countryName, locality),
    backgroundColor,
    pronouns,
    highlightColor
  };
};
exports.presentProfile = presentProfile;
function formatLocation(countryName, locality) {
  return countryName && locality ? `${locality}, ${countryName}` : countryName || locality || null;
}
function formatIntroduction(role, orgName) {
  return role && orgName ? `${role} at ${orgName}` : orgName || role || null;
}
function getColors(subject, store) {
  const backgroundColor = store.anyValue(subject, _solidUi.ns.solid('profileBackgroundColor'), null, subject.doc());
  const highlightColor = store.anyValue(subject, _solidUi.ns.solid('profileHighlightColor'), null, subject.doc());
  return {
    // default colors are coming from the SolidOS theme, so we only want to set them here if they're valid colors
    backgroundColor: validColorOrDefault(backgroundColor, ''),
    highlightColor: validColorOrDefault(highlightColor, '')
  };
}
function validColorOrDefault(color, fallback) {
  return color && (0, _validateColor.validateHTMLColorHex)(color) ? color : fallback;
}